import type { DailyBonusCardState } from '@/components/entities/dailyBonus/components/DailyBonusCard';

type DailyBonusKeysType = IntlMessages['daily-bonus']['information'];

interface InfoCard {
  rewardAmount: number;
  bonusDays: number;
  state: DailyBonusCardState;
  titleKey: keyof DailyBonusKeysType;
  subTitleKey: keyof DailyBonusKeysType;
}

export const infoDailyRewardCards: InfoCard[] = [
  {
    bonusDays: 7,
    rewardAmount: 0.5,
    state: 'ready',
    titleKey: 'claim',
    subTitleKey: 'ready-to-claim',
  },
  {
    bonusDays: 6,
    rewardAmount: 25,
    state: 'claimed',
    titleKey: 'wait',
    subTitleKey: 'already-claimed-for-today',
  },
  {
    bonusDays: 0,
    rewardAmount: 25,
    state: 'locked',
    titleKey: 'unlock',
    subTitleKey: 'buy-bundle-to-get-7',
  },
];
